import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { changePasswordController } from "../controllers/changePasswordController";

import * as changePassword from "../redux/modules/changePassword";

class ChangePassword extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    redirectToSignIn: PropTypes.bool.isRequired,
    redirectToHome: PropTypes.bool.isRequired,
    inputForm: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    errorMessages: PropTypes.object,
  };

  componentDidMount() {
    this.props.dispatch(changePasswordController.checkChangePasswordRequired());
  }

  onSubmit = (e) => {
    e.preventDefault();

    const { password, passwordConfirmation } = this.props.inputForm;
    if (password && passwordConfirmation) {
      this.props.dispatch(
        changePasswordController.updatePassword(
          this.props.inputForm.password,
          this.props.inputForm.passwordConfirmation
        )
      );
    } else {
      alert("パスワードを入力してください");
      return false;
    }
  };

  render() {
    if (this.props.redirectToSignIn) {
      window.location.replace("/sign-in/?unauthorized=1");
    } else if (this.props.redirectToHome) {
      window.location.replace("/");
    }

    // パスワード
    let passwordInvalidFeedback = "";
    // 新しいパスワード
    let passwordConfirmationInvalidFeedback = "";

    // サーバーサイドエラーのフィードバック
    if (this.props.errorMessages) {
      if (this.props.errorMessages.password) {
        const items = [];
        for (let message of this.props.errorMessages.password) {
          items.push(<li>新しいパスワード {message}</li>);
        }
        passwordInvalidFeedback = (
          <div className="invalid-feedback">
            <ul>{items}</ul>
          </div>
        );
      }

      if (this.props.errorMessages.password_confirmation) {
        const items = [];
        for (let message of this.props.errorMessages.password_confirmation) {
          items.push(<li>新しいパスワード（確認用） {message}</li>);
        }
        passwordConfirmationInvalidFeedback = (
          <div className="invalid-feedback">
            <ul>{items}</ul>
          </div>
        );
      }
    }

    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col-12 my-3">
              <h1 style={{ fontSize: "1.5rem" }}>
                新しいパスワードを登録してください
              </h1>
            </div>
            <div className="col-12 mb-3">
              <p>
                初回ログインにつき、新しいパスワードの登録が必要です。下記の入力フォームにて、登録作業の完了をお願い致します。
              </p>
            </div>
            <div className="col-12 col-sm-6">
              <form onSubmit={this.onSubmit}>
                <div className="form-group">
                  <input
                    type="password"
                    className={
                      "form-control " +
                      (passwordInvalidFeedback ? "is-invalid" : "")
                    }
                    placeholder="新しいパスワード"
                    value={this.props.inputForm.password || ""}
                    onChange={(e) => {
                      this.props.dispatch(
                        changePassword.actions.inputForm({
                          formId: "password",
                          value: e.target.value,
                        })
                      );
                    }}
                  />
                  <small className="form-text text-muted">
                    半角で、小文字英字・大文字英字・記号・数字のすべてを含むように、10～32文字で設定してください。使用できる記号は!@.-_です。<br />
                    同一の数字・英字を連続させたり、連続した数字や英字を並べた文字列を含むパスワードは設定できません。
                  </small>
                  {passwordInvalidFeedback}
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className={
                      "form-control " +
                      (passwordConfirmationInvalidFeedback ? "is-invalid" : "")
                    }
                    placeholder="新しいパスワード（確認用）"
                    value={this.props.inputForm.passwordConfirmation || ""}
                    onChange={(e) => {
                      this.props.dispatch(
                        changePassword.actions.inputForm({
                          formId: "passwordConfirmation",
                          value: e.target.value,
                        })
                      );
                    }}
                  />
                  {passwordConfirmationInvalidFeedback}
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={this.props.isFetching}
                >
                  登録
                </button>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect((state) => {
  const core = state.core || {};
  const apiUnauthorized = core.apiUnauthorized || {};
  const changePassword = state.changePassword || {};
  const inputForm = changePassword.inputForm || {};

  return {
    redirectToSignIn: !!apiUnauthorized.redirectToSignIn,
    redirectToHome: !!changePassword.backToHome || !!changePassword.succeeded,
    inputForm: { ...inputForm },
    isFetching: !!changePassword.isFetching,
    errorMessages: changePassword.errorMessages,
  };
})(ChangePassword);
